// Web Push subscriptions (JAR-2389): this device's subscription, kept by core
// (JAR-2397), which sends a push for each new bell notification.

import { api, ApiRequestError } from './client';

/** Core's answer while it has no VAPID keys: push isn't available yet. */
const PUSH_NOT_CONFIGURED = 'PUSH_NOT_CONFIGURED';

export function isPushNotConfigured(error: unknown): boolean {
  return error instanceof ApiRequestError && (error.detailCode === PUSH_NOT_CONFIGURED || error.code === PUSH_NOT_CONFIGURED);
}

/** The VAPID public key a device subscribes with. */
export async function getPushKey(): Promise<string> {
  const result = await api.get<{ public_key?: unknown }>('/notifications/push/key');
  if (result.error) throw result.error;
  const key = result.data?.public_key;
  if (typeof key !== 'string' || key === '') throw new Error('The push key response carried no key');
  return key;
}

/** Saves this device's subscription: the browser's own toJSON(), as is. */
export async function savePushSubscription(subscription: PushSubscriptionJSON): Promise<void> {
  const result = await api.post('/notifications/push/subscriptions', subscription);
  if (result.error) throw result.error;
}

/** Removes this device's subscription. The endpoint goes in the body, not the
 *  URL, because it carries a per-device token. */
export async function deletePushSubscription(endpoint: string): Promise<void> {
  const result = await api.del('/notifications/push/subscriptions', { endpoint });
  if (result.error) throw result.error;
}
